import React, { ReactElement } from 'react';

import { Wrapper } from './styles';

interface Props {
  children: ReactElement;
}

const LeftPane: React.FC<Props> = ({ children }) => <Wrapper data-testid='left-pane__wrapper'>{children}</Wrapper>;

export default LeftPane;
